import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
export class LogResponseData extends SolidifyableData {
}
;
//# sourceMappingURL=LogResponseData.js.map